// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5106) return "static/chunks/5106-db0f15b667aec022.js";
	if (chunkId === 1554) return "static/chunks/1554-b68330233d13366f.js";
	if (chunkId === 7318) return "static/chunks/7318-8204f729dce8133e.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"688":"44d23085d23590e6","2366":"aaf466a527c86066","5366":"67df4fddc3027664","9364":"47ee7d59813b6eaa"}[chunkId] + ".js";
};